module.exports = __webpack_public_path__ + "images/Caviar/Warning-ad55c484bd0f2ced9768d24067bbb48e.svg";